// Mapa tras wymagajacych code-splittingu, uzywana WYLACZNIE do preloadu PRZED hydrateRoot (main.jsx).
// Jawna lista zamiast regexow tam gdzie latwo o pomylke (np. prawdziwe trasy generatora vs stare
// "/generator-dokumentow-*", ktore sa tylko przekierowaniami i nie maja wlasnego chunku).
// Dokladnie odzwierciedla tabele tras w App.jsx - przy zmianie jednej, zmienic obie.

const NORM_ID_BY_PATH = {
  '/generator-iso-9001': '9001',
  '/generator-iso-14001': '14001',
  '/generator-iso-14001-2026': '14001-2026',
  '/generator-iso-45001': '45001',
  '/generator-iso-27001': '27001',
  '/generator-iso-22301': '22301',
  '/generator-iatf-16949': '16949',
  '/generator-vda-63': 'vda63',
  '/generator-nis2': 'nis2',
  '/generator-iso-42001': '42001',
  '/generator-aqap-2110': 'aqap2110',
  '/generator-aqap-2210': 'aqap2210',
  '/generator-aqap-2131': 'aqap2131',
  '/generator-gdp': 'gdp',
};

const ROUTE_CHUNKS = [
  // 26.07: /app (AppShell) byl jedyna trasa lazy() w App.jsx BEZ wpisu tutaj - zawsze zawieszal
  // sie na Suspense fallbacku przy pierwszym renderze hydratacji (dokladnie blad opisany w App.jsx
  // przy pozostalych trasach), mimo ze react-snap crawlujac lokalnie (chunk laduje sie natychmiast)
  // zdazyl zlapac juz w pelni wyrenderowany LoginScreen. Stad hydration mismatch #418/#423 na /app
  // niezaleznie od stanu theme/lang/isMobile - ten wpis to prawdziwa, brakujaca przyczyna.
  { key: 'AppShell', test: p => p === '/app' || p.startsWith('/app/'), load: () => import('./components/AppShell'), props: () => ({}) },
  { key: 'AiSeoPage', test: p => p === '/ai-seo', load: () => import('./components/AiSeoPage'), props: () => ({}) },
  { key: 'PartnerPage', test: p => p === '/partner', load: () => import('./components/PartnerPage'), props: () => ({}) },
  { key: 'GapAuditLandingPage', test: p => p === '/gap-audit', load: () => import('./components/GapAuditLandingPage'), props: () => ({}) },
  { key: 'PowerModulesLandingPage', test: p => p === '/power-modules', load: () => import('./components/PowerModulesLandingPage'), props: () => ({}) },
  { key: 'HLSBuilderLandingPage', test: p => p === '/hls-builder', load: () => import('./components/HLSBuilderLandingPage'), props: () => ({}) },
  { key: 'AqapLandingPage', test: p => p === '/aqap-2110', load: () => import('./components/AqapLandingPage'), props: () => ({}) },
  { key: 'Aqap2131LandingPage', test: p => p === '/aqap-2131', load: () => import('./components/Aqap2131LandingPage'), props: () => ({}) },
  { key: 'GdpLandingPage', test: p => p === '/gdp', load: () => import('./components/GdpLandingPage'), props: () => ({}) },
  { key: 'DemoPage', test: p => p === '/demo', load: () => import('./components/DemoPage'), props: () => ({}) },
  { key: 'PakietyPage', test: p => p === '/pakiety', load: () => import('./components/PakietyPage'), props: () => ({}) },
  { key: 'NormPage', test: p => Object.prototype.hasOwnProperty.call(NORM_ID_BY_PATH, p), load: () => import('./components/NormPage'), props: p => ({ normId: NORM_ID_BY_PATH[p] }) },
  // Gap Assessment by MQS (10.08): blog i cennik wlasne dla tego produktu (nie odziedziczony
  // BlogPage.jsx z ISO Forge, ten zostaje martwy pod trasa /blog dopoki jest wylaczona wyzej).
  { key: 'GapBlogPage', test: p => p === '/blog' || p.startsWith('/blog/'), load: () => import('./components/gap/BlogPage'), props: () => ({}) },
  { key: 'GapCennikPage', test: p => p === '/cennik', load: () => import('./components/gap/CennikPage'), props: () => ({}) },
  { key: 'GapSampleReportPage', test: p => p === '/przyklad-raportu', load: () => import('./components/gap/SampleReportPage'), props: () => ({}) },
  // 25.07: przeniesione z "zostaja eager" na lazy - PageSpeed mobile flagowal ich kod jako
  // niepotrzebnie sciagany na kazdej stronie (patrz komentarz w App.jsx przy imporcie).
  { key: 'PrivacyPage', test: p => p === '/polityka-prywatnosci', load: () => import('./components/PrivacyPage'), props: () => ({}) },
  { key: 'TermsPage', test: p => p === '/regulamin', load: () => import('./components/TermsPage'), props: () => ({}) },
];

// Wywolywane raz w main.jsx, PRZED hydrateRoot. Zwraca null jesli biezaca trasa nie wymaga
// preloadu (strona glowna - jedyna ktora zostaje eager, bez zmian) - albo
// { path, Component, props } gdy trafiono dopasowanie i modul zdazyl sie zaladowac.
export async function preloadInitialRoute(pathname) {
  // Serwery statyczne (react-snap/serve/nginx) przekierowuja "/trasa" -> "/trasa/" dla
  // katalogow-per-trasa w dist/, wiec window.location.pathname moze miec koncowy ukosnik
  // zanim ten kod sie uruchomi - bez normalizacji dopasowanie ponizej nigdy by nie trafilo,
  // renderRoute() spadalby na Suspense fallback i psul hydratacje (#418/#423).
  if (pathname.length > 1 && pathname.endsWith('/')) pathname = pathname.slice(0, -1);
  const match = ROUTE_CHUNKS.find(r => r.test(pathname));
  if (!match) return null;
  try {
    const mod = await match.load();
    return { path: pathname, key: match.key, Component: mod.default, props: match.props(pathname) };
  } catch {
    // Siec/parsowanie zawiodly - nie blokujemy hydratacji, App.jsx uzyje zwyklego lazy()+Suspense
    // (real user zobaczy krotki fallback zamiast natychmiastowej tresci, ale strona dziala).
    return null;
  }
}
